import auth from '@lcai/console-auth';
import encodeUserName from './encode-user-name';

/**
 * 这里的逻辑和 helper 中稍有重叠，但不适合依赖之，否则会造成循环依赖
 */
export default function getDefaultParamsUser() {
  var account = auth();
  return {
    // TODO 需要一个管理登录信息的模块
    USER_LOGGED: !!account.token,
    USER_ID: account.id,
    USER_NAME: encodeUserName(account.name)
  };
}
//# sourceMappingURL=get-default-params-user.js.map